<ng-container *ngIf="reports$ | async as reports">
  <alert *ngIf="!reports.length" type="danger">
    Este panel no contiene informes
  </alert>

  <p-accordion
    [multiple]="true"
    (onOpen)="onOpen($event)"
    [(activeIndex)]="activeIndex"
  >
    <p-accordionTab *ngFor="let report of reports">
      <ng-template pTemplate="header">
        <div class="header">
          <div>
            <span [innerHTML]="report.title | markdown"></span>
          </div>
          <div class="comment-buttons">
            <button
              type="button"
              pButton
              icon="pi pi-comment"
              class="p-button-text"
              (click)="openCommentDialog($event, report)"
              [ngStyle]="{ color: report.comments?.length ? 'blue' : 'black' }"
            ></button>
            <div class="comment-count" *ngIf="report.comments?.length">
              {{ report.comments?.length }}
            </div>
          </div>
        </div>
      </ng-template>

      <app-iframe-viewer
        [url]="report.url"
        [width]="report.width"
        [height]="report.height"
        [widthUnit]="report.widthUnit"
        [heightUnit]="report.heightUnit"
        [visible]="report.visible"
      ></app-iframe-viewer>
    </p-accordionTab>
  </p-accordion>
</ng-container>
